import { render, staticRenderFns } from "./lead.vue?vue&type=template&id=c2442df0&scoped=true"
import script from "./lead.vue?vue&type=script&lang=js"
export * from "./lead.vue?vue&type=script&lang=js"
import style0 from "./lead.vue?vue&type=style&index=0&id=c2442df0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2442df0",
  null
  
)

export default component.exports